import React, { useEffect, useMemo, useState, useCallback } from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { isEmpty } from "lodash"
import "bootstrap/dist/css/bootstrap.min.css"
import * as Yup from "yup"
import { useFormik } from "formik"
import imageBaseUrl from '../../../../helpers/imageBaseUrl'
//import components
import Breadcrumbs from "../../../../components/Common/Breadcrumb"

// import {
//   getUsers as onGetUsers,
//   addNewUser as onAddNewUser,
//   updateUser as onUpdateUser,
//   deleteUser as onDeleteUser,
// } from "../../../store/actions"

import {
  Description_ar,
  Description_en,
  Description_fr,
  Is_vendor,
  // Position,
 Name_ar,Name_en,Name_fr
} from "./FaqListCol"

//redux
import { useSelector, useDispatch } from "react-redux"

import {
  Col,
  Row,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  Spinner,
} from "reactstrap"
import DeleteModal from "../../../../components/Common/DeleteModal"
import Dropzone from "react-dropzone"
import { addNewHowitwork, deleteHowitwork, getHowitworks } from "../../../../store/how_it_works/actions"
import ReactSelect from "react-select"
import { addNewFaq, deleteFaq, getFaqs, updateFaq } from "../../../../store/faq/actions"
import TableContainer from "../../../../components/Common/TableContainer"


function Faqs() {
  const [modal, setModal] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [page,setPage]=useState(0)
  const [page_size, setPageSize] = useState(20)
  const [ceremony, setCeremony] = useState([])
  const [isVendor, setIsVendor] = useState({label:'Client',value:0})
const [selectedFiles, setselectedFiles] = useState([])

function handleAcceptedFiles(files) {
  files.map(file =>
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    })
  )

  setselectedFiles(files)

}

/**
 * Formats the size
 */
function formatBytes(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes"
  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
}
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      question_en: (ceremony && ceremony.question_en) || "",
      question_ar: (ceremony && ceremony.question_ar) || "",
      question_fr: (ceremony && ceremony.question_fr) || "",
      answer_en: (ceremony && ceremony.answer_en) || "",
      answer_fr: (ceremony && ceremony.answer_fr) || "",
      answer_ar: (ceremony && ceremony.answer_ar) || "",
      type: (ceremony && ceremony.type) || "",
      is_active: (ceremony && ceremony.is_active) || 0,
    },

    // validationSchema: Yup.object({
    //   name_ar: Yup.string().required("name ar is required"),
    //   name_fr: Yup.string().required("name fr is required"),
    //   name_en: Yup.string().required("name en is required"),
    // }),

    onSubmit: values => {

      if (isEdit) {
        const UpdateCeremony = {
          id: ceremony ? ceremony.id : 0,
          question_en: values["question_en"],
          question_fr: values["question_fr"],
          question_ar: values["question_ar"],
          answer_ar: values["answer_ar"],
          answer_en: values["answer_en"],
          answer_fr: values["answer_fr"],
          is_active: values["is_active"],
          type:values["type"],
        }

        // update ceremony
        dispatch(updateFaq(UpdateCeremony))
        validation.resetForm()
      } else {
        const newCeremony = {
          question_en: values["question_en"],
          question_fr: values["question_fr"],
          question_ar: values["question_ar"],
          answer_ar: values["answer_ar"],
          answer_en: values["answer_en"],
          answer_fr: values["answer_fr"],
          is_active: values["is_active"],
          type:values["type"],
        }
        // save new ceremony
        dispatch(addNewFaq(newCeremony))
        validation.resetForm()
        setselectedFiles([])
      }
      // toggle()
    },
  })

  const dispatch = useDispatch()
  const howitworks = useSelector(state => state.faq.faqs)
  const total_pages = useSelector(state => state.faq.total_pages)
  const loading = useSelector(state => state.faq.loading)

  useEffect(() => {
    // if (howitworks && !howitworks.length) {
      dispatch(getFaqs({is_active:0,offset:page,page_size}))
    // }
  }, [dispatch,page,page_size])

  // useEffect(() => {
  //   if (howitworks && !howitworks.length) {
  //     dispatch(onGetUsers())
  //   }
  // }, [dispatch, howitworks])

  // useEffect(() => {
  // }, [howitworks])

  useEffect(() => {
    if (!isEmpty(howitworks)) {
      setIsEdit(false)
    }
  }, [howitworks])

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false)
      setCeremony(null)
    } else {
      setModal(true)
    }
  }, [modal]);

  const handleUserClick = useCallback((arg) => {
    const ceremony = arg
   ceremony?.image ? setselectedFiles([
      {
        preview:imageBaseUrl+ceremony.image
      }
    ]) : setselectedFiles([])
    setIsVendor(ceremony.for_vendor == 1 ? {label:'Vendor',value:1} : {label:'Client',value:0})
    setCeremony({
      id: ceremony["id"],
      question_en: ceremony["question_en"],
      question_fr: ceremony["question_fr"],
      question_ar: ceremony["question_ar"],
      answer_ar: ceremony["answer_ar"],
      answer_en: ceremony["answer_en"],
      answer_fr: ceremony["answer_fr"],
      is_active: ceremony["is_active"],
      type:ceremony["type"],

    })
    setIsEdit(true)
    toggle()
  }, [toggle])

  //delete ceremony
  const [deleteModal, setDeleteModal] = useState(false)

  const onClickDelete = ceremony => {
    setCeremony(ceremony)
    setDeleteModal(true)
  }

  const handleDeleteUser = () => {
    if (ceremony.id) {
      dispatch(deleteFaq(ceremony))
    }
  }
  useEffect(() => {
    if(!loading){
      setDeleteModal(false)
           setModal(false) 
    } 

  },[loading])
  const handleUserClicks = () => {
    setIsEdit(false)
    toggle()
  }
  const columns = useMemo(
    () => [
      // {
      //   Header: "Id",
      //   accessor: "checkbox",
      //   disableFilters: true,
      //   filterable: false,
      //   Cell: cellProps => {
      //     return <input type="checkbox" className="selection-input-4" />
      //   },
      // },
      // {
      //   Header: "Image",

      //   filterable: true,
      //   disableFilters: true,
      //   accessor: cellProps => (
      //     <React.Fragment>
      //       {!cellProps.image ? (
      //         <div className="avatar-xs d-inline-block me-2">
      //           <div className="avatar-title bg-soft-primary rounded-circle text-primary">
      //             <i className="mdi mdi-account-circle m-0"></i>
      //           </div>
      //         </div>
      //       ) : (
      //         <>
      //           <img
      //             className="avatar-xs rounded-circle me-2"
      //             src={imageBaseUrl + cellProps?.image}
      //             alt=""
      //           />
      //         </>
      //       )}
      //     </React.Fragment>
      //   ),
      // },
      {
        Header: "Question en",
        accessor: "question_en",
        filterable: true,
        Cell: cellProps => {
          return <Name_en {...cellProps} />
        },
      },
      // {
      //   Header: "Position",
      //   accessor: "designation",
      //   filterable: true,
      //   Cell: cellProps => {
      //     return <Position {...cellProps} />
      //   },
      // },
      {
        Header: "Question fr",
        accessor: "question_fr",
        filterable: true,
        Cell: cellProps => {
          return <Name_fr {...cellProps} />
        },
      },
      {
        Header: "Question ar",
        accessor: "question_ar",
        filterable: true,

        Cell: cellProps => {
          return <Name_ar {...cellProps} />
        },
        
      },
      {
        Header: "Answer en",
        accessor: "answer_en",
        filterable: true,

        Cell: cellProps => {
          return <Description_en {...cellProps} />
        },
        
      },
      {
        Header: "Answer fr",
        accessor: "answer_fr",
        filterable: true,

        Cell: cellProps => {
          return <Description_ar {...cellProps} />
        },
        
      },
      {
        Header: "Answer ar",
        accessor: "answer_ar",
        filterable: true,

        Cell: cellProps => {
          return <Description_fr {...cellProps} />
        },
      },
      {
        Header: "Type",
        accessor: "type",
        filterable: false,
        disableFilters: true,

        Cell: cellProps => {
          // eslint-disable-next-line react/jsx-pascal-case
          return <Is_vendor {...cellProps} />
        },
        
      },
      {
        Header: "Active",
        accessor: "is_active",
        filterable: true,
        disableFilters: true,

        Cell: cellProps => (
          // {
          //   return <IsActive {...cellProps} />
          // },
          <div className="form-check form-switch form-switch-lg">
            {cellProps.value == 1 ? (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateFaq({
                      is_active: 0,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={true}
              />
            ) : (
              <input
                disabled={loading}
                onClick={e =>
                  dispatch(
                    updateFaq({
                      is_active: 1,
                      id: cellProps.row.original.id,
                    })
                  )
                }
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizelg"
                checked={false}
              />
            )}
          </div>
        ),
      },
      {
        Header: "Action",
        accessor: "action",
        disableFilters: true,
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3 users">
              <ul className="list-inline font-size-20 contact-links mb-0">
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-primary"
                    onClick={() => {
                      const howitworks = cellProps.row.original
                      handleUserClick(howitworks)
                    }}
                  >
                    <i className="uil uil-pen font-size-18" id="edittooltip" />
                    <UncontrolledTooltip placement="top" target="edittooltip">
                      Edit
                    </UncontrolledTooltip>
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to="#"
                    className="text-danger"
                    onClick={() => {
                      const howitworks = cellProps.row.original
                      onClickDelete(howitworks)
                    }}
                  >
                    <i
                      className="uil uil-trash-alt font-size-18"
                      id="deletetooltip"
                    />
                    <UncontrolledTooltip placement="top" target="deletetooltip">
                      Delete
                    </UncontrolledTooltip>
                  </Link>
                </li>
                {/* <li className="list-inline-item dropdown">
                  <UncontrolledDropdown>
                    <DropdownToggle
                      tag="a"
                      className="text-muted font-size-18 px-2"
                      caret
                    >
                      <i className="uil uil-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                      <DropdownItem href="#">Action</DropdownItem>
                      <DropdownItem href="#">Another action</DropdownItem>
                      <DropdownItem href="#">Something else here</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </li> */}
              </ul>
            </div>
          )
        },
      },
    ],
    [handleUserClick]
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
        loading={loading}
      />
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="MENU" breadcrumbItem="Faq" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <TableContainer
                    columns={columns}
                    data={howitworks}
                    isGlobalFilter={true}
                    isAddUsers={true}
                    isAddTableWithoutBorderStrap={true}
                    handleUserClicks={handleUserClicks}
                    setPage={setPage}
                    page_number={page}
                    total_pages={total_pages}
                    setPageSize={setPageSize}
                    page_size={page_size}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle} tag="h4">
              {!!isEdit ? "Edit User" : "Add Users"}
            </ModalHeader>
            <ModalBody>
              <Form
                onSubmit={e => {
                  e.preventDefault()
                  validation.handleSubmit()
                  return false
                }}
              >

                <Row>
                  <Col className="col-12">
                    {/* <div className="mb-3">
                      <Label className="form-label">Position</Label> */}
                    {/* <Input
                        name="designation"
                        type="designation"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.designation || ""}
                        invalid={
                          validation.touched.designation &&
                          validation.errors.designation
                            ? true
                            : false
                        }
                      /> */}
                    {/* {validation.touched.designation &&
                      validation.errors.designation ? (
                        <FormFeedback type="invalid">
                          {validation.errors.designation}
                        </FormFeedback>
                      ) : null} */}
                    {/* </div> */}
                    <div className="mb-3">
                      <Label className="form-label">Question en</Label>
                      <Input
                        name="question_en"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.question_en || ""}
                        invalid={
                          validation.touched.question_en &&
                          validation.errors.question_en
                            ? true
                            : false
                        }
                      />
                      {validation.touched.question_en &&
                      validation.errors.question_en ? (
                        <FormFeedback type="invalid">
                          {validation.errors.question_en}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Question fr</Label>
                      <Input
                        name="question_fr"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.question_fr || ""}
                        invalid={
                          validation.touched.question_fr &&
                          validation.errors.question_fr
                            ? true
                            : false
                        }
                      />
                      {validation.touched.question_fr &&
                      validation.errors.question_fr ? (
                        <FormFeedback type="invalid">
                          {validation.errors.question_fr}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Question ar</Label>
                      <Input
                        name="question_ar"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.question_ar || ""}
                        invalid={
                          validation.touched.question_ar &&
                          validation.errors.question_ar
                            ? true
                            : false
                        }
                      />
                      {validation.touched.question_ar &&
                      validation.errors.question_ar ? (
                        <FormFeedback type="invalid">
                          {validation.errors.question_ar}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Answer en</Label>
                      <Input
                        name="answer_en"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.answer_en || ""}
                        invalid={
                          validation.touched.answer_en &&
                          validation.errors.answer_en
                            ? true
                            : false
                        }
                      />
                      {validation.touched.answer_en &&
                      validation.errors.answer_en ? (
                        <FormFeedback type="invalid">
                          {validation.errors.answer_en}
                        </FormFeedback>
                      ) : null}
                    </div> <div className="mb-3">
                      <Label className="form-label">Answer fr</Label>
                      <Input
                        name="answer_fr"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.answer_fr || ""}
                        invalid={
                          validation.touched.answer_fr &&
                          validation.errors.answer_fr
                            ? true
                            : false
                        }
                      />
                      {validation.touched.answer_fr &&
                      validation.errors.answer_fr ? (
                        <FormFeedback type="invalid">
                          {validation.errors.answer_fr}
                        </FormFeedback>
                      ) : null}
                    </div> <div className="mb-3">
                      <Label className="form-label">Answer ar</Label>
                      <Input
                        name="type"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.type || ""}
                        invalid={
                          validation.touched.type &&
                          validation.errors.type
                            ? true
                            : false
                        }
                      />
                      {validation.touched.type &&
                      validation.errors.type ? (
                        <FormFeedback type="invalid">
                          {validation.errors.type}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="form-label">Type</Label>
                      <Input
                        name="answer_ar"
                        type="text"
                        validate={{
                          required: { value: true },
                        }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.answer_ar || ""}
                        invalid={
                          validation.touched.answer_ar &&
                          validation.errors.answer_ar
                            ? true
                            : false
                        }
                      />
                      {validation.touched.answer_ar &&
                      validation.errors.answer_ar ? (
                        <FormFeedback type="invalid">
                          {validation.errors.answer_ar}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      {validation.values.is_active === 1 ? (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          defaultChecked
                          onClick={() => (validation.values.is_active = 0)}
                        />
                      ) : (
                        <input
                          type="checkbox"
                          className="selection-input-4 m-1"
                          onClick={() => (validation.values.is_active = 1)}
                        />
                      )}
                      {/* <input
                        type="checkbox"
                        className="selection-input-4 m-1"
                        defaultChecked={
                          validation.values.is_active === 1 ? true : false
                        }
                      /> */}
                      <Label className="form-label">Active</Label>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <div className="text-end">
                      {loading ? (
                        <Spinner
                          type="grow"
                          className="m-1 center"
                          color="primary"
                        />
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-success save-user"
                        >
                          Save
                        </button>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </ModalBody>
          </Modal>
        </div>
      </div>
    </React.Fragment>
  )
}
Faqs.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default Faqs
